import { type ProductCategory } from "@/data/productDatabase";
import { Battery, Disc3, type LucideIcon, Speaker, Volume2, Zap } from "lucide-react";

export interface CompareCategoryOption {
  id: ProductCategory;
  label: string;
  mobileLabel: string;
  icon: LucideIcon;
}

export const compareCategoryOptions: CompareCategoryOption[] = [
  { id: "subwoofer", label: "Subwoofers", mobileLabel: "Subs", icon: Disc3 },
  { id: "amplifier", label: "Amplifiers", mobileLabel: "Amps", icon: Zap },
  { id: "speaker", label: "Speakers", mobileLabel: "Spkrs", icon: Speaker },
  { id: "tweeter", label: "Tweeters", mobileLabel: "Tweets", icon: Volume2 },
  { id: "alternator", label: "Alternators", mobileLabel: "Alts", icon: Battery },
];

export const compareCategoryLabels: Record<ProductCategory, string> = {
  subwoofer: "Subwoofers",
  amplifier: "Amplifiers",
  speaker: "Speakers",
  tweeter: "Tweeters",
  alternator: "Alternators",
};
